import { getStore } from '~/store/helpers';
import { getAllowedChannels, getCurrentChannel } from '~/selectors';
import { FormErrorMessages } from '~/constants';

const required = (value) => {
  const name = value?.trim();

  return name === '' ? FormErrorMessages.CHANNEL_NAME_IS_REQUIRED : true;
};

const uniqueChannelName = (value) => {
  const name = value?.trim();

  const store = getStore();
  const state = store.getState();
  const currentChannel = getCurrentChannel(state);

  const channels = getAllowedChannels(state).filter(
    (channel) => channel.id !== currentChannel?.id
  );

  const names = channels.map((channel) => channel.config.name);

  if (names.includes(name)) return FormErrorMessages.CHANNEL_DUPLICATE_NAME;

  return true;
};

const generateMinLengthMessage = (value) =>
  `Min length is ${value} character${value === 1 ? '' : 's'}.`;

const generateMaxLengthMessage = (value) =>
  `Max length is ${value} character${value === 1 ? '' : 's'}.`;

const FormValidations = {
  required,
  uniqueChannelName,
  generateMinLengthMessage,
  generateMaxLengthMessage,
};

export { FormValidations };
